import * as THREE from "three";
import { clamp, damp } from "./utils.js";

/**
 * A small camera hierarchy that keeps future yaw, pitch and dolly controls
 * independent. Stage 02 uses pointer parallax; later stages feed gesture intent
 * into the same public methods.
 */
export class CameraRig {
  constructor(aspect = 1) {
    this.root = new THREE.Group();
    this.root.name = "CameraRig";

    this.yawGroup = new THREE.Group();
    this.pitchGroup = new THREE.Group();
    this.camera = new THREE.PerspectiveCamera(42, aspect, 0.1, 100);

    this.root.add(this.yawGroup);
    this.yawGroup.add(this.pitchGroup);
    this.pitchGroup.add(this.camera);

    this.camera.position.set(0, 0, 8.4);
    this.root.position.y = 0.08;

    this.pointer = new THREE.Vector2();
    this.targetDistance = 8.4;
  }

  setPointer(x, y) {
    this.pointer.set(clamp(x, -1, 1), clamp(y, -1, 1));
  }

  setDistance(distance) {
    this.targetDistance = clamp(distance, 4.5, 13);
  }

  resize(width, height) {
    this.camera.aspect = width / Math.max(height, 1);
    this.camera.updateProjectionMatrix();
  }

  update(delta) {
    const targetYaw = -this.pointer.x * 0.055;
    const targetPitch = this.pointer.y * 0.04;

    this.yawGroup.rotation.y = damp(
      this.yawGroup.rotation.y,
      targetYaw,
      3.2,
      delta,
    );
    this.pitchGroup.rotation.x = damp(
      this.pitchGroup.rotation.x,
      targetPitch,
      3.2,
      delta,
    );
    this.camera.position.z = damp(
      this.camera.position.z,
      this.targetDistance,
      4,
      delta,
    );
    this.root.position.x = damp(
      this.root.position.x,
      this.pointer.x * 0.06,
      2.4,
      delta,
    );
    this.root.position.y = damp(
      this.root.position.y,
      0.08 + this.pointer.y * 0.04,
      2.4,
      delta,
    );
  }
}
